import React, { useEffect, useState } from "react";
import {
  Image,
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FormattedMessage } from "react-intl";
import AsyncStorage from "@react-native-async-storage/async-storage";
import styles from "./styles";
import { If, Then, Else } from "react-if";

const MyAccount = ({ navigation }) => {
  const [level, setLevel] = useState(1);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const levelUser = await AsyncStorage.getItem("level");

    setLevel(parseInt(levelUser));
  }

  return (
    <>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.container}>
          <View style={styles.contentTitle}>
            <Image
              style={styles.icones}
              source={require("../../../assets/user_cadastro.svg")}
            />
            <Text style={styles.title}>
              <FormattedMessage id="myAccount.cadastro" />
            </Text>
          </View>

          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => navigation.navigate("UpdateRegistration")}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.atualizaCadastro" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => navigation.navigate("ReportIncome")}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.informeRendimentos" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <If condition={level >= 1}>
              <Then>
                <View style={styles.itemList}>
                  <TouchableOpacity
                    style={styles.contentItemList}
                    onPress={() => navigation.navigate("IncomeVoucher")}
                  >
                    <Text style={styles.textItemList}>
                      <FormattedMessage id="myAccount.comprovanteRenda" />
                    </Text>
                  </TouchableOpacity>
                  <View style={styles.hrLine}></View>
                </View>
              </Then>
              <Else>
                <></>
              </Else>
            </If>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => navigation.navigate("BankAccount")}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.contaBancaria" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <If condition={level >= 1}>
              <Then>
                <>
                  <View style={styles.itemList}>
                    <TouchableOpacity
                      style={styles.contentItemList}
                      onPress={() => navigation.navigate("InvestorProfile")}
                    >
                      <Text style={styles.textItemList}>
                        <FormattedMessage id="myAccount.perfilInvestidor" />
                      </Text>
                    </TouchableOpacity>
                    <View style={styles.hrLine}></View>
                  </View>

                  <View style={styles.itemList}>
                    <TouchableOpacity
                      style={styles.contentItemList}
                      onPress={() => navigation.navigate("MyQualification")}
                    >
                      <Text style={styles.textItemList}>
                        <FormattedMessage id="myAccount.atualizacaoNivel" />
                      </Text>
                    </TouchableOpacity>
                    <View style={styles.hrLine}></View>
                  </View>
                </>
              </Then>{" "}
              <Else>{null}</Else>
            </If>
          </View>

          <View style={styles.contentTitle}>
            <Image
              style={styles.icones}
              source={require("../../../assets/user_security.svg")}
            />
            <Text style={styles.title}>
              <FormattedMessage id="myAccount.seguranca" />
            </Text>
          </View>
          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => navigation.navigate("ChangePassword")}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.alterarSenha" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
          </View>

          <View style={styles.contentTitle}>
            <Image
              style={styles.icones}
              source={require("../../../assets/user_help.svg")}
            />
            <Text style={styles.title}>
              <FormattedMessage id="myAccount.ajuda" />
            </Text>
          </View>
          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => {
                  //navigation.navigate('TermsService')
                  Linking.canOpenURL(
                    "https://api.gpxecofi.com.br/termos-privacidade"
                  ).then((supported) => {
                    if (supported) {
                      Linking.openURL(
                        "https://api.gpxecofi.com.br/termos-privacidade"
                      );
                    } else {
                      console.log("url blocked");
                    }
                  });
                }}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.termosUso" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <View style={styles.itemList}>
              <TouchableOpacity
                style={styles.contentItemList}
                onPress={() => {
                  Linking.canOpenURL("https://gpxexchange.com.br/help").then(
                    (supported) => {
                      if (supported) {
                        Linking.openURL("https://gpxexchange.com.br/help");
                      } else {
                        //console.log('url blocked');
                      }
                    }
                  );
                }}
              >
                <Text style={styles.textItemList}>
                  <FormattedMessage id="myAccount.centralAjuda" />
                </Text>
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
          </View>
        </View>
        <TouchableOpacity
          style={styles.buttonContainer}
          onPress={async () => {
            /*   await AsyncStorage.removeItem("keep_logged"); */
            navigation.navigate("Welcome");
          }}
        >
          <Text style={styles.buttonText}>
            <FormattedMessage id="myAccount.sairConta" />
          </Text>
        </TouchableOpacity>
      </ScrollView>
    </>
  );
};

export default MyAccount;
